import Main from './components/Main';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import { BrowserRouter as Router } from 'react-router-dom'
import './App.css'
import { useColorMode } from '@chakra-ui/react';

function App() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'
  return (
    <Router>
      <div id={ !isDark ? 'home_light' : 'home' }>
        <Header />
        <Main />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </div>      
    </Router>
  );
}

export default App;
